import React from "react";
import { withStyles } from "@material-ui/core/styles";
import AutoZoom from "./AutoZoom";

const styles = (theme) => ({
  headerStyle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    border: `1px solid ${theme.AppBGColor}`,
    marginBottom: 1,
    borderRadius: "4px 4px 0 0",
    padding: "9px 9px",
    fontSize: theme.headerTextFontSize,
    lineHeight: "16px",
    color: theme.HeaderSelectedText,
  },
  label: {
    marginLeft: 6,
  },
});

const MapHeader = ({
  classes,
  label,
  isAutoZoomEnabled,
  toggleRouteAnimation,
  userData,
}) => (
  <div className={classes.headerStyle}>
    <span className={classes.label}>{label}</span>
    <span>
      <AutoZoom
        isEnabled={isAutoZoomEnabled}
        toggleRouteAnimation={toggleRouteAnimation}
        userData={userData}
      />
    </span>
  </div>
);

export default withStyles(styles)(MapHeader);
